import { ICreateLauncherModalService } from "./i-create-launcher-modal.service";
import { Inject, Injectable } from "@angular/core";
import { IModalService, modalServiceInjectionToken } from "@zaeper/angular-dashboard-view-lib";
import { CreateLauncherModalComponent } from "./create-launcher-modal.component";
import { ICreateLauncherModalOptions } from "./i-create-launcher-modal.options";

@Injectable()
export class CreateLauncherModalService implements ICreateLauncherModalService {
  constructor(@Inject( modalServiceInjectionToken ) private readonly _modalService: IModalService) {
  }

  public open(options: ICreateLauncherModalOptions): void {
    this._modalService.open( CreateLauncherModalComponent, {
      styleClass: 'bg-white rounded-lg',
      header: "Launcher erstellen",
      showHeader: true,
      closable: true,
      width: '900px',
      closeOnEscape: true,
      dismissableMask: true,
      data: options
    } )
  }
}
